export const LIVE_TEACHER_HEADER_LANDING = 'LIVE_TEACHER_HEADER_LANDING';
export const LIVE_TEACHER_HEADER_LANDING_ORIGINAL = 'A';
export const LIVE_TEACHER_HEADER_LANDING_VARIATION = 'B';
export const ALL_USER_FREE_TRIAL = 'ALL_USER_FREE_TRIAL';
export const ALL_USER_FREE_TRIAL_ORIGINAL = 'A';
export const ALL_USER_FREE_TRIAL_VARIATION = 'B';
export const SIGNUP_SOCIAL_POSITION = 'SIGNUP_SOCIAL_POSITION';
export const SIGNUP_SOCIAL_POSITION_ORIGINAL = 'A';
export const SIGNUP_SOCIAL_POSITION_VARIATION = 'B';
const experiments = {
    [LIVE_TEACHER_HEADER_LANDING]: {
        experimentId: '19059923999',
        variations: {
            19077215745: LIVE_TEACHER_HEADER_LANDING_ORIGINAL,
            19163100890: LIVE_TEACHER_HEADER_LANDING_VARIATION
        }
    },
    [ALL_USER_FREE_TRIAL]: {
        experimentId: '19653920650',
        variations: {
            19574801875: ALL_USER_FREE_TRIAL_ORIGINAL,
            19584734574: ALL_USER_FREE_TRIAL_VARIATION
        }
    },
    [SIGNUP_SOCIAL_POSITION]: {
        experimentId: '20357711741',
        variations: {
            20320621168: SIGNUP_SOCIAL_POSITION_ORIGINAL,
            20344211520: SIGNUP_SOCIAL_POSITION_VARIATION
        }
    }
};
export default experiments;
